import { HttpService, Query, QueryHandler, TaggedUrl, Tags } from '@skylab-shared/core';
import { fillPlaceholders } from '@skylab-shared/utils';

export class SaleDocumentGetIdByExternalIdQuery extends Query<number> {
	public constructor(public readonly params: { externalId: string }) {
		super()
	}
}

export class SaleDocumentGetIdByExternalIdQueryHandlerBase implements QueryHandler<SaleDocumentGetIdByExternalIdQuery, number> {
	private static Url = TaggedUrl.join('sales/:externalId/id', [Tags.Api]);

	public constructor(private readonly http: HttpService) { }

	public async handleAsync(query: SaleDocumentGetIdByExternalIdQuery): Promise<number> {
		const url = fillPlaceholders(SaleDocumentGetIdByExternalIdQueryHandlerBase.Url, { externalId: query.params.externalId });
		const result = await this.http.get(url);
		return result.data.value;
	}
}
